import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { adminAreaFindByPageParams, adminAreaListByParentIdParams, adminAreaSaveParams, adminAreaDeleteParams } from '@/typings/api/gucangSale'

/**
 * ************************************** 行政区域 **************************************
 */
// 分页查询行政区域
export function adminAreaFindByPage(data: adminAreaFindByPageParams) {
  return request.post<AxiosResult>('/base/api/adminArea/findByPage', data)
}
// 查询行政区域列表
export function adminAreaListByParentId(data?: adminAreaListByParentIdParams) {
  return request.post<AxiosResult>('/base/api/adminArea/listByParentId', data)
}
// 保存行政区域
export function adminAreaSave(data: adminAreaSaveParams) {
  return request.post<AxiosResult>('/base/api/adminArea/save', data)
}
// 更新行政区域
export function adminAreaUpdate(data: adminAreaSaveParams) {
  return request.post<AxiosResult>('/base/api/adminArea/update', data)
}
// 删除行政区域
export function adminAreaDelete(data: adminAreaDeleteParams) {
  return request.post<AxiosResult>('/base/api/adminArea/delete', data)
}
